import { ArrowRight, Phone } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end pt-28 pb-16"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/27312708/pexels-photo-27312708.jpeg')",
        }}
        aria-hidden
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/65 to-black" aria-hidden />
      <div className="absolute inset-0 bg-grid opacity-50" aria-hidden />

      <div className="relative z-10 px-6 md:px-12 lg:px-20 w-full">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-9 animate-fade-up">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-px bg-[#FFD600]" />
              <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#FFD600]">
                Saint John, New Brunswick
              </span>
            </div>

            <h1 className="font-display font-bold uppercase tracking-tighter leading-[0.85] text-5xl sm:text-7xl lg:text-8xl xl:text-[9rem]">
              <span className="block">Industrial</span>
              <span className="block">Strength.</span>
              <span className="block text-[#FFD600]">Bubble Clean.</span>
            </h1>

            <p className="mt-10 max-w-2xl text-base sm:text-lg text-gray-300 leading-relaxed">
              Mobile pressure washing built for the East Coast — from heritage homes to heavy
              equipment. We bring the rig, the pressure, and the spotless finish to your door.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#quote"
                data-testid="hero-quote-btn"
                className="group bg-[#FFD600] text-black font-bold uppercase tracking-wider px-8 py-5 inline-flex items-center gap-3 hover:-translate-y-1 hover:shadow-[6px_6px_0_0_rgba(255,255,255,0.25)] transition-all"
              >
                Get a Free Quote
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="tel:+15066084350"
                data-testid="hero-call-btn"
                className="border border-white/30 text-white font-bold uppercase tracking-wider px-8 py-5 inline-flex items-center gap-3 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors"
              >
                <Phone size={18} />
                (506) 608-4350
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 hidden lg:flex flex-col gap-6 border-l border-[#2A2A2A] pl-8">
            <div>
              <div className="font-display text-5xl text-[#FFD600] font-bold">4000</div>
              <div className="text-xs uppercase tracking-widest text-gray-400 mt-1">PSI Power</div>
            </div>
            <div>
              <div className="font-display text-5xl text-white font-bold">12+</div>
              <div className="text-xs uppercase tracking-widest text-gray-400 mt-1">Years Local</div>
            </div>
            <div>
              <div className="font-display text-5xl text-[#00E5FF] font-bold">7</div>
              <div className="text-xs uppercase tracking-widest text-gray-400 mt-1">Service Types</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom edge ticker */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-[#2A2A2A] bg-black/60 backdrop-blur-sm">
        <div className="px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between text-[11px] uppercase tracking-[0.3em] text-gray-400">
          <span>Fully Insured</span>
          <span className="hidden md:inline">Eco-Safe Detergents</span>
          <span className="hidden md:inline">Soft Wash Certified</span>
          <span>Residential · Commercial · Fleet</span>
        </div>
      </div>
    </section>
  );
}
